var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { cssColorValue, IconMenu, IconX, screenSmMax, } from '@spotify-internal/encore-web/core';
import { MenuButton } from './MenuButton';
import React from 'react';
import styled from 'styled-components';
import { useS4AMastheadContext } from '../../../../S4AMastheadProvider';
import { SideFlyoutTopBarZIndex } from '../../../constants';
var MenuButtonWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: none;\n  z-index: ", ";\n  @media (max-width: ", ") {\n    display: flex;\n    position: relative;\n  }\n"], ["\n  display: none;\n  z-index: ", ";\n  @media (max-width: ", ") {\n    display: flex;\n    position: relative;\n  }\n"])), SideFlyoutTopBarZIndex, screenSmMax);
export var MenuTrigger = function (_a) {
    var isMenuOpen = _a.isMenuOpen, onOpen = _a.onOpen, onClose = _a.onClose;
    var mastheadData = useS4AMastheadContext().mastheadData;
    return (React.createElement(React.Fragment, null, !isMenuOpen ? (React.createElement(MenuButtonWrapper, null,
        React.createElement(MenuButton, { size: "medium", "data-testid": "navigation-sidemenu-trigger", iconOnly: IconMenu, tabIndex: 0, onKeyDown: function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                    onOpen();
                }
            }, onClick: onOpen, "aria-label": mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData.fields.dropdownMenuLabelOpen, "aria-expanded": isMenuOpen }))) : (React.createElement(MenuButtonWrapper, null,
        React.createElement(MenuButton, { size: "medium", iconOnly: IconX, onClick: onClose, onKeyDown: function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                    onClose();
                }
            }, color: cssColorValue('textBase'), tabIndex: 0, "aria-label": mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData.fields.dropdownMenuLabelClose })))));
};
var templateObject_1;
